import {
    Badge,
    List,
    ListItem,
    ListItemText,
    Typography,
    Box,
    Chip,
    IconButton,
    Button as MatButton,
    Grid2,
    useTheme
} from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import API from '../../api/axios';
import moment from 'moment';
import { getUser } from "../../utils/types";
import React, { useEffect, useState, ReactNode, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import DataNotFound from '../DataNotFound/DataNotFound';
import Button from "../../components/Button/Button";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import DataLoader from '../DataLoader/DataLoader';
import SystemNotificationTab from "./SystemNotificationTab"
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useDispatch } from "react-redux";
import { togglePageTrigger } from "../../store/slices/notificationSlice";
import { Padding } from '@mui/icons-material';

interface NotificationCategory {
    id: number;
    name: string;
}

interface Notification {
    is_read: boolean;
    notification_cat_id: {
        id: number;
        name: string;
    };
}

interface Notification {
    date_created: string;
    date_updated: string | null;
    id: number;
    is_read: boolean;
    message: string;
    recipient_id: string;
    status: string;
    subject: string;
    user_created: string | null;
    user_updated: string | null;
    view_link: string | null;
    tbl_pk_id: number | null;
    notification_cat_id: { id: number; name: string; };
}

    const SystemNotificationDialog: React.FC = () => {
    const [recipientid, setRecipientid] = useState()
    const [roleCode, setRoleCode] = useState<any>()
    const [open, setOpen] = useState(false);
    const [notificationTypes,setNotificationTypes] = useState<any>([])
    const [value, setValue] = useState("");
    const [notificationData, setNotificationData] = useState<Notification[]>([]);
    const [tabUnreadNotificationIds,setTabUnreadNotificationIds] = useState<any>([]);
    const [readNotificationTypes,setReadNotificationTypes] = useState<string[]>([])
    const [unreadNotificationCount,setUnreadNotificationCount] = useState<any>([])
    const [isRead,setIsRead] = useState<any>(false)
    const [storedNotifications, setStoredNotifications] = useState<Record<string, Notification[]>>({});
    const [loading, setLoading] = useState(false);
    const [hasBidder, setHasBidder] = useState<boolean>(false);
    const [unreadCountLoading, setUnreadCountLoading] = useState(false);
    const [rerender, setRerender] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const theme = useTheme(); 

    useEffect(() => {
        if (notificationTypes.length > 0) {
          setValue(notificationTypes[0].id.toString());
        }
      }, [notificationTypes]);
    
    const countTrigger = useSelector((state: RootState) => state.notification?.dialogTrigger);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setNotificationData([])
        setValue(newValue);
    };

    useEffect(()=>{
    const data = getUser();
    setRecipientid(data?.user?.id);

    let role = data?.roles?.role_code;
    if (
      role !== "administrator" &&
      role !== "interviewer" &&
      role !== "candidate" &&
      role !== "bidder" &&
      role !== "nhai_officials"
    ) {
      role = "talent_admin";
    }
    setRoleCode(role);
    },[])

    useEffect(()=>{
        if(roleCode){
            getMasterNotification()
        }
        },[roleCode])

    const getMasterNotification = async () : Promise<void> =>{
        try{
            const masterNotificationResponse = await API.get("/items/master_generals?fields=id,type,name,target_users&filter[type]=notification_category&filter[status]=published&sort[]=sort&limit=-1");
           
      let formattedNotifications = masterNotificationResponse?.data?.data
        .filter(
          (item: any) =>
            item.target_users.includes(roleCode) ||
            (roleCode === "nhai_officials" &&
              item.target_users.includes("talent_admin"))
        )
        .map((item: any) => ({ id: item.id, name: item.name }));

      if (roleCode === "nhai_officials") {
        formattedNotifications = formattedNotifications.filter((item: any) =>
          item.name.toLowerCase().includes("system notification")
        );
      }

      setNotificationTypes(formattedNotifications);

            // for conditional display of notification icon for bidder  
            const hasBidder = masterNotificationResponse?.data?.data.some((item: any) => item.target_users.includes("bidder"));
            setHasBidder(hasBidder);
            
        }catch(err){
            // Failed to fetch notification master
        }
    }

    useEffect(() => {
        if (recipientid && !unreadCountLoading) {
          getNotificationsUnreadCount(); // Call function when countTrigger changes
        }
      }, [countTrigger]);

    useEffect(() => {
        if(((roleCode!=="bidder")|| (hasBidder))){
        if (recipientid && !unreadCountLoading) {
        getNotificationsUnreadCount()
        dispatch(togglePageTrigger());
        }
    }
    }, [recipientid,value]);

    const getNotificationsUnreadCount = async (): Promise<void> => {
        setUnreadCountLoading(true)

        if (roleCode === "nhai_officials") {
          setUnreadNotificationCount([]);
          setUnreadCountLoading(false);
          return;
        }

        try {
            const response = await API.get(`/items/system_notifications?aggregate[count]=*&filter[recipient_id]=${recipientid}&filter[is_read]=false&filter[status]=published&groupBy=notification_cat_id&offset=0&limit=100&meta=*`);

         // Get new unread counts data
         const newUnreadCounts = response?.data?.data || [];
        
         // Update unread notification count
         setUnreadNotificationCount(newUnreadCounts);
         
        // console.log(newUnreadCounts,"newUnreadCounts");
        // console.log(storedNotifications,"StoredNotifications");
        // console.log(readNotificationTypes,"readNotificationTypes");
 
         // Get all notification category IDs from newUnreadCounts
         const unreadCategoryIds = newUnreadCounts.map((item: any) => item.notification_cat_id);
 

        setStoredNotifications((prev) => {
            const updated = Object.keys(prev)
                .filter((key) => !unreadCategoryIds.includes(Number(key))) // Keep only items not in unreadCategoryIds
                .reduce((acc, key) => {
                    acc[key] = prev[key];
                    return acc;
                }, {} as Record<string, Notification[]>);
            return updated;
        });
        
        // Remove from readNotificationTypes if ID matches unread notification category IDs
        setReadNotificationTypes((prev) =>
            prev.filter((type) => !unreadCategoryIds.includes(Number(type)))
        );
        
        } catch (error) {
            // Failed to fetch notification unread count
        }finally{
            setUnreadCountLoading(false)
        }
    };

    const getNotifications = async (): Promise<void> => {
        const hasUnread = unreadNotificationCount.find((unread: any) => unread.notification_cat_id == value && Number(unread.count) > 0)
        

        let IsRead = hasUnread ? false : true;
        let numberofNotifications = hasUnread ? -1 : 25;
        setIsRead(IsRead);

        try {

            const response = await API.get(`/items/system_notifications?fields=*,notification_cat_id.id,notification_cat_id.name,notification_cat_id.target_users&filter[status]=published&filter[recipient_id]=${recipientid}&sort[]=-id&offset=0&limit=${numberofNotifications}&meta=*&filter[is_read]=${IsRead}&filter[notification_cat_id.id]=${value}`);

                    if (response?.data?.data?.length > 0) { 
                        setStoredNotifications((prev) => ({
                            ...prev,
                            [value]: response?.data?.data, 
                        }));
                    }  
                      
           setReadNotificationTypes((prev) => {
            const updatedSet = new Set(prev); 
            updatedSet.add(value); 
            return Array.from(updatedSet); 
        });

        

           if(!IsRead){
            const unreadNotificationsIds = response?.data?.data?.map((unreadNotification:any)=>unreadNotification.id)
            setTabUnreadNotificationIds(unreadNotificationsIds)
            NotificationMarkRead(unreadNotificationsIds);
        }

        } catch (error) {
            // Failed to fetch notification unread count
        }finally{
            setRerender((prev)=> !prev);
        }
    };

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;

        if(((roleCode!=="bidder")|| (hasBidder))){
        if (recipientid && !open) {
            // Start polling only when the drawer is closed
            intervalId = setInterval(() => {
                getNotificationsUnreadCount();
            }, 300000);
        }
    }
    
    return () => {
        // Clear the interval when component unmounts or when `open` changes to true (drawer opens)
        if (intervalId) {
            clearInterval(intervalId);
        }
    }
    }, [recipientid, open]);

    useEffect(() => {
    if (!value) return;

    if (roleCode === "nhai_officials") {
      setNotificationData([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const toGetData = readNotificationTypes.find(
      (readNotificationType: string) => {
        return readNotificationType.trim() === value.trim();
      }
    );
        
        if (recipientid ) {
            if(!toGetData && open){
                getNotifications();
            }else{
                setNotificationData(storedNotifications[value.trim()])  
                setLoading(false);
            }
        }
    }, [open, value, rerender]);
    // console.log(readNotificationTypes,"readNotificationTypes");
    

        const NotificationMarkRead = (unreadNotificationsIds:any) =>{
            // console.log(unreadNotificationsIds,"unreadNotificationsIds");
        if(unreadNotificationsIds?.length > 0) {
         try{
        API.post("/notification/status/update/read",
            {
                "notificationIds": unreadNotificationsIds
            }
        )
        }catch(error){
            // Failed to mark notifications as read
        }
    }
    }

    const handleDrawerClose = () => {
        if(notificationTypes){
            setValue(notificationTypes[0].id.toString());  // Reset to default tab
        }
        setReadNotificationTypes([]); // Reset read types
        setStoredNotifications({}); // Clear stored notifications
        setTabUnreadNotificationIds([])
        getNotificationsUnreadCount()
    };

    
    const handleDrawerToggle = (): void => {
        if (open) {
            handleDrawerClose();
            setOpen(false);
        } else {
            setOpen(true);
        }
    };

    const formatDate = (dateString: string): string => {
        return moment(dateString).format('D MMM YYYY');
    };
    
    const totalUnreadCount = unreadNotificationCount.reduce((sum:any, item:any) => sum + Number(item.count), 0);
    
    return (
        <>
        { ((roleCode!=="bidder")|| (hasBidder)) &&
            (<IconButton className="notification-icon-button" 
            onClick={()=>{
                handleDrawerToggle();
                }} >
                <Badge badgeContent={totalUnreadCount} color="primary" className="notification-badge"
                    sx={{
                        "& .MuiBadge-badge": {
                            backgroundColor: "#fb8b0e",
                            color: "white",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                        },
                    }} >
                    <NotificationsNoneOutlinedIcon
                        className="notification-icon"
                    />
                </Badge>
            </IconButton>)
    }
                    {/* Drawer Component */}
            <Drawer
                anchor="right"
                open={open}
                onClose={()=>{
                    handleDrawerToggle()   
                }}
                PaperProps={{
                    sx: {
                        width: {xs: "250px", sm:"450px", md: "30vw"},
                        maxWidth: {xs: "250px",sm:"450px", md: "30vw"},
                        overflow: "hidden",
                    },
                }}
            >
                 {/* Drawer Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "15px",
                        borderBottom: "1px solid",
                        borderColor: theme.palette.mode === "light" ? "#eee" : "#222",
                    }}
                >
                    <Typography variant="h6" sx={{ fontSize: "20px" }}>
                        Notifications
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleDrawerToggle}
                        disableRipple
                        sx={{
                            backgroundColor: "#fb8b0e",
                            borderRadius: "50% !important",
                            width: "30px",
                            height: "30px",
                            padding: 0,
                            "&:hover": {
                                backgroundColor: "#AF6109", 
                            },
                        }}
                    >
                        <CloseIcon sx={{color: "white", width: "0.75em", height: "0.75em"}}/>
                    </IconButton>
                </Box>
                    
                    <TabContext value={value}>
                                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                        <TabList
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="tabs"
                                        sx={{
                                            ".MuiTabs-indicator": {
                                            height:"0.2rem",
                                            backgroundColor: "#fb8b0e" ,
                                            },
                                            ".MuiButtonBase-root.Mui-selected": {
                                            backgroundColor:theme.palette.mode === "light" ? "#ffffff" : "",
                                            color: "#fb8b0e",
                                            border: 0,
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            borderRadius: "0px !important",
                                            },
                                            ".MuiButtonBase-root": {
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            borderRadius: "0px !important", 
                                            },
                                        }}
                                        >
                                            {/* Each tab head  */}
                                            {value &&
                                            notificationTypes?.map((notificationType:any)=>(
                                                <Tab 
                                                key={notificationType?.id}
                                                sx={{ overflow: 'visible' }}
                                           label={
                                            <Badge  badgeContent={
                                                (() => {
                                                    const matchingNotification = unreadNotificationCount.find((count: any) =>
                                                        count?.notification_cat_id === notificationType?.id
                                                    );
                                                    return matchingNotification?.count || 0;
                                                })()
                                            }  color="secondary" 
                                               sx={{
                                                   overflow:'visible',
                                                   '& .MuiBadge-badge': {
                                                   top: -4,  
                                                   right: -6, 
                                                   }
                                               }}
                                               >
                                               <span>{notificationType?.name}</span>
                                               </Badge>
                                           } 
                                        value={`${notificationType?.id}`} 
                                           />
                                            ))}               
                                        </TabList>
                                    </Box>
                                    {/* Notifications List */}
                    {notificationTypes?.map((notificationTypes:any)=>(             
                    <TabPanel
                    key={notificationTypes?.id}
                    value={`${notificationTypes?.id}`}
                    sx={{
                    padding: 0,
                    marginY: "1rem",
                    height: "72vh",
                    overflowY: "auto",
                    "&::-webkit-scrollbar": { width: "8px" },
                    "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
                    "&::-webkit-scrollbar-thumb": { background: "#888", borderRadius: "50px" },
                    "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
                    }}>
                   <SystemNotificationTab 
                    notificationData={notificationData}  
                    loading={loading}  
                    handleDrawerToggle={handleDrawerToggle}  
                    formatDate={formatDate}  />
                 </TabPanel>
                 ))}
                     </TabContext>
                {/* Footer Action */}
                <Box sx={{ padding: 2, display:"flex", justifyContent:"center", alignItems:"center", position:"absolute",bottom:"0px", width:"100%"}}>
                    <Button
                        variant="secondary"
                        variantType="contained"
                        label="See All Notifications"
                        onClick={() => {
                            handleDrawerToggle();
                            navigate("/admin/notifications");
                        }}
                        style={{
                            textTransform: "none",
                            borderRadius: "8px",
                            width:"90%",
                            marginRight:"32px"
                        }}
                    />
                </Box>
            </Drawer>
        </>
    );
};

export default SystemNotificationDialog;